/* Parquelectro: adds "Entrega inmediata" to the custom sort menu.
   Shopify has no such sort key, so the option toggles the own-stock filter. */
(function () {
  'use strict';
  var FKEY = 'filter.p.m.parquelectro.entrega';

  function inject() {
    var menu = document.querySelector('.pe-sort__menu');
    if (!menu || menu.querySelector('.pe-sort__opt--inm')) return;
    var on = new URL(location.href).searchParams.get(FKEY) === 'Inmediata';
    var opt = document.createElement('button');
    opt.type = 'button';
    opt.className = 'pe-sort__opt pe-sort__opt--inm' + (on ? ' is-on' : '');
    opt.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2L5 13h5l-1 9 9-12h-5z"/></svg>Entrega inmediata';
    opt.addEventListener('click', function (e) {
      e.stopPropagation();
      var u = new URL(location.href);
      if (u.searchParams.get(FKEY) === 'Inmediata') u.searchParams.delete(FKEY);
      else u.searchParams.set(FKEY, 'Inmediata');
      u.searchParams.delete('page');
      location.href = u.toString();
    });
    menu.insertBefore(opt, menu.firstChild);
  }

  function start() {
    inject();
    new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
